import { Vector } from '@inter-ikea-core/core';
import { IpexViewerComponent } from './IpexViewerComponent';
export function getCanvasCoordinates(event) {
    return new Vector(event.canvas_x, event.canvas_y, 0);
}
export function fromMeters(x) {
    return x * 1000;
}
export function toMeters(x) {
    return x / 1000;
}
export function toVectorUnscaled(vector) {
    const { x, y } = vector;
    const z = 'z' in vector ? vector.z : 0;
    return new Vector(x, y, z);
}
export function toVector(vector) {
    const { x, y } = vector;
    const z = 'z' in vector ? vector.z : 0;
    return new Vector(fromMeters(x), fromMeters(y), fromMeters(z));
}
export function toIVector3(vector) {
    return {
        x: toMeters(vector.X),
        y: toMeters(vector.Y),
        z: toMeters(vector.Z)
    };
}
export function rgb(r, g, b) {
    return { r, g, b };
}
/**
 * Gets the @IpexViewerComponent stored on @SceneManager .root
 * Note that you need to place it there first yourself, once you have access to the viewer.
 *
 * @param sceneManager
 * @returns
 */
export function getIpexViewer(sceneManager) {
    return sceneManager.root.getComponent(IpexViewerComponent.ID)?.viewer;
}
export function setIpexViewer(sceneManager, entityManager, viewer) {
    if (viewer)
        sceneManager.root.addComponent(new IpexViewerComponent(viewer));
    else
        sceneManager.root.removeComponent(IpexViewerComponent.ID);
}
//# sourceMappingURL=util.js.map